<mat-form-field
  class="relative z-10 h-full w-[60px]"
  subscriptSizing="dynamic"
  appearance="outline"
  [ngClass]="formClass"
  [class.!z-50]="shouldShowError"
  [class.cursor-not-allowed]="control.disabled"
  [class.disabled-with-errors]="control.disabled && control.errors"
  (click)="clickValidateForDisabled()"
>
  <input
    #inputRef
    type="number"
    class="!pointer-events-none text-center"
    matInput
    [class.cursor-not-allowed]="control.disabled"
    [formControl]="control"
    (input)="trimAndValidateControl()"
    (click)="clickValidateForDisabled()"
    (blur)="handleFocusChange()"
  />
  <!-- We have to use a material hint and not a material error since material errors can't show on disabled fields! -->
  @if (shouldShowError && control.touched && control.errors) {
    <mat-hint class="absolute z-40 mt-1 w-48 rounded border bg-white p-2 text-red-500 shadow-md">
      @if (control.hasError('temporalOverflowError')) {
        The daily total should not be more than 24 hours
      }
      @if (control.hasError('notActiveForDayError')) {
        This employee is not active for this day
      }
      @if (control.hasError('multipleRecordsForDayError')) {
        There are multiple records for this entry. It must be fixed by a General Foreman
      }
      @if (control.hasError('alreadyApprovedError')) {
        This record has already been approved and can only be modified by a General Foreman
      }
      @if (control.hasError('invalidCostingError')) {
        Entry cannot be made due to missing costing information. Contact your General Foreman or Davey Time Administrator
      }
    </mat-hint>
  }
</mat-form-field>
